import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cartItems: localStorage.getItem("cartItems")
        ? JSON.parse(localStorage.getItem("cartItems"))
        : [],
    cartTotalQuantity: 0,
    cartTotalAmount: 0,
};

const getItemMatchKey = (item) => {
    if (!item) return '';
    const id = item.id ?? item._id ?? '';
    const variantId = item.variantId ?? '';
    const size = item.selectedSize ?? '';
    const color = item.selectedColor ?? '';
    return `${id}___${variantId}___${size}___${color}`;
};

export const productSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart(state, action) {
            const payloadKey = getItemMatchKey(action.payload);
            const existingIndex = state.cartItems.findIndex(
                (item) => getItemMatchKey(item) === payloadKey && payloadKey !== '______'
            );
            if (existingIndex >= 0) {
                state.cartItems[existingIndex] = {
                    ...state.cartItems[existingIndex],
                    cartQuantity: (state.cartItems[existingIndex].cartQuantity || 1) + (action.payload.cartQuantity || 1),
                };
            } else {
                let tempProductItem = { 
                    ...action.payload, 
                    id: action.payload.id ?? action.payload._id,
                    cartQuantity: action.payload.cartQuantity || 1 
                };
                state.cartItems.push(tempProductItem);
            }
            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
        },
        decreaseCart(state, action) {
            const payloadKey = getItemMatchKey(action.payload);
            const itemIndex = state.cartItems.findIndex(
                (item) => getItemMatchKey(item) === payloadKey
            );
            if (itemIndex >= 0) {
                if (state.cartItems[itemIndex].cartQuantity > 1) {
                    state.cartItems[itemIndex].cartQuantity -= 1;
                } else {
                    state.cartItems.splice(itemIndex, 1);
                }
            }
            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
        },
        removeFromCart(state, action) {
            const payloadKey = getItemMatchKey(action.payload);
            state.cartItems = state.cartItems.filter(
                (item) => getItemMatchKey(item) !== payloadKey
            );
            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
        },
        getTotals(state, action) {
            let { total, quantity } = state.cartItems.reduce(
                (cartTotal, cartItem) => {
                     const price = parseFloat(cartItem.price) || 0;
                     const cartQuantity = parseInt(cartItem.cartQuantity) || 1;
                     const itemTotal = price * cartQuantity;
                     cartTotal.total += itemTotal;
                     cartTotal.quantity += cartQuantity;
                     return cartTotal;
                },
                {
                    total: 0,
                    quantity: 0,
                }
            );
            total = parseFloat(total.toFixed(2));
            state.cartTotalQuantity = quantity;
            state.cartTotalAmount = total;
        },
        clearCart(state, action) {
            state.cartItems = [];
            localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
        },
    },
});

export const { addToCart, decreaseCart, removeFromCart, getTotals, clearCart } = productSlice.actions;
export default productSlice.reducer;